interface DailyData {
  date: string
  views: number
  unique_visitors: number
}

interface DailyChartProps {
  data: DailyData[]
  loading: boolean
}

function formatDateShort(dateStr: string): string {
  const date = new Date(dateStr + 'T00:00:00')
  return date.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit' })
}

function DailyChart({ data, loading }: DailyChartProps) {
  if (loading) {
    return (
      <div className="analytics-card">
        <h2 className="section-title">Visites par jour</h2>
        <div className="chart-loading">Chargement...</div>
      </div>
    )
  }

  if (data.length === 0) {
    return (
      <div className="analytics-card">
        <h2 className="section-title">Visites par jour</h2>
        <div className="chart-empty">Aucune donnée pour cette période</div>
      </div>
    )
  }

  const maxViews = Math.max(...data.map((d) => d.views), 1)

  return (
    <div className="analytics-card">
      <h2 className="section-title">Visites par jour</h2>
      <div className="daily-chart">
        <div className="chart-bars">
          {data.map((day) => {
            const heightPercent = (day.views / maxViews) * 100
            return (
              <div key={day.date} className="chart-bar-wrapper" title={`${day.date}\n${day.views} vues\n${day.unique_visitors} visiteurs uniques`}>
                <div className="chart-bar-container">
                  <div
                    className="chart-bar"
                    style={{ height: `${heightPercent}%` }}
                  >
                    {heightPercent > 20 && (
                      <span className="chart-bar-value">{day.views}</span>
                    )}
                  </div>
                </div>
                <span className="chart-bar-label">{formatDateShort(day.date)}</span>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default DailyChart
